import env from '~/src/utils/env';

export const getBannersUrl = (orgFprint: string) =>
  `${env.apiUrl}/clients/api/v1/org/${orgFprint}/banners/`;
